import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../../utils";
import { notification } from "antd";

export const useTopProducts = () => {
  return useQuery({
    queryKey: ["getTopProducts"], // ✅ Static key
    queryFn: () => fetchData("/vendor/gettopproducts"), // ✅ No params
    staleTime: 5 * 60 * 1000, // optional
    refetchOnWindowFocus: false, // optional
    onError: () =>
      notification.error({
        key: "topProductsError",
        message: "Failed to retrieve Top Products",
      }),
  });
};
